export default "<p>\n  loan-status works!\n</p>\n";